"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const arrowback = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-arrowback` : '') + (description ? ` desc-arrowback` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-arrowback"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-arrowback"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.648 1.52985L1.02296 11.3298C0.991664 11.3617 0.963287 11.3951 0.934051 11.4345L0.872314 11.5313L0.827548 11.6217L0.783545 11.7493L0.769272 11.808L0.754169 11.9132L0.750122 11.9908C0.750122 12.0943 0.763597 12.1872 0.790087 12.2755L0.832495 12.389L0.893466 12.5046C0.937068 12.5733 0.977439 12.6238 1.02296 12.6702L10.648 22.4702L10.7384 22.5505C11.1245 22.8431 11.647 22.8061 11.977 22.4702L12.0558 22.3781L12.1256 22.2688C12.3316 21.8947 12.2749 21.4333 11.977 21.1298L3.94395 12.95H22.3125L22.4228 12.943C22.9027 12.8773 23.25 12.4757 23.25 12L23.2437 11.8894C23.1896 11.4176 22.7942 11.05 22.3125 11.05H3.94195L11.9769 2.87016L12.0558 2.77814C12.3406 2.38856 12.3047 1.8636 11.977 1.52985C11.6105 1.15672 11.0144 1.15672 10.648 1.52985Z",
    fill: "inherit"
  }));
};
var _default = exports.default = arrowback;